// action types
export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_ERROR = "API_ERROR";
export const API_REQUEST_SAVE_BLOG = "API_REQUEST_SAVE_BLOG"
export const CANCEL_API_REQUEST = "CANCEL_API_REQUEST";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const PASSWORD_RESET_REQUIRED = "PASSWORD_RESET_REQUIRED";
export const SAVE_BLOG = "SAVE_BLOG";
export const BLOG_SAVED = "BLOG_SAVED";
export const UPDATE_BLOG = "UPDATE_BLOG"
export const BLOG_UPDATED = "BLOG_UPDATED"
export const FETCH_BLOGS = "FETCH_BLOGS";
export const BLOGS_FETCHED = "BLOGS_FETCHED";
export const FETCH_BLOG = "FETCH_BLOG";
export const BLOG_FETCHED = "BLOG_FETCHED";
export const CREATE_USER = "CREATE_USER"
export const FETCH_USERS = "FETCH_USERS"
export const USERS_FETCHED = "USERS_FETCHED";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES"
export const CATEGORIES_FETCHED = "CATEGORIES_FETCHED"
export const FETCH_LANGUAGES = "FETCH_LANGUAGES"
export const FETCH_STATICS = "FETCH_STATICS"
export const STATICS_FETCHED = "STATICS_FETCHED"
export const UPDATE_STATICS = "UPDATE_STATICS"
export const STATICS_UPDATED = "STATICS_UPDATED"
export const LANGUAGES_FETCHED = "LANGUAGES_FETCHED"
export const CREATE_ROLE = "CREATE_ROLE"
export const FETCH_ROLES = "FETCH_ROLES"
export const ROLES_FETCHED = "ROLES_FETCHED"
export const FETCH_DEVICES = "FETCH_DEVICES"
export const DEVICES_FETCHED = "DEVICES_FETCHED"
export const UPDATE_DEVICE = "UPDATE_DEVICE";
export const DEVICE_UPDATED = "DEVICE_UPDATED";
export const REQUEST_REGISTER = "REQUEST_REGISTER";
export const REGISTER_REQUESTED = "REGISTER_REQUESTED";
export const FETCH_ATTENDANCE = "FETCH_ATTENDANCE";
export const ATTENDANCE_FETCHED = "ATTENDANCE_FETCHED";
export const RECORD_ATTENDANCE = "RECORD_ATTENDANCE";
export const ATTENDANCE_RECORDED = "ATTENDANCE_RECORDED";
export const CUSTOM_MIDDLE_REQUEST = "CUSTOM_MIDDLE_REQUEST";
export const CUSTOM_MIDDLE_RESPONSE = "CUSTOM_MIDDLE_RESPONSE";
export const TRANSLATE_TEXT = "TRANSLATE_TEXT";
export const TRANSLATED = "TRANSLATED";
export const UP_PGR = "UPLOAD_PROGRESS"
export const DN_PGR = "DOWNLOAD_PROGRESS"

// action creators
export const apiRequest = ({ url, method, data, requestFor, headers, params }) => {
  return {
    type: API_REQUEST,
    meta: { url, method, data, headers, params },
    requestFor
  };
};

export const apiRequestSaveBlog = ({ getPresignedUrl, saveBlogUrl, data, headers }) => {
  return {
    type: API_REQUEST_SAVE_BLOG,
    meta: { getPresignedUrl, saveBlogUrl, data, headers },
  };
};


export const cancelApiRequest = () => {
  return {
    type: CANCEL_API_REQUEST
  };
};

export const apiSuccess = ({ response }) => ({
  type: API_SUCCESS,
  payload: response
});

export const apiError = ({ error }) => ({
  type: API_ERROR,
  payload: error
});

// export const loginResponse = ({ response }) => ({
//   type: LOGIN_RESPONSE,
//   payload: response
// })

export const loginSuccess = ({ response }) => ({
  type: LOGIN_SUCCESS,
  payload: response
})

export const passwordResetRequired = ({ response }) => ({
  type: PASSWORD_RESET_REQUIRED,
  payload: response
})

export const blogsFetched = ({ response }) => ({
  type: BLOGS_FETCHED,
  payload: response
})

export const blogFetched = ({ response }) => ({
  type: BLOG_FETCHED,
  payload: response
})

export const translated = ({ response }) => ({
  type: TRANSLATED,
  payload: response
})

export const saveBlog = (payload) => ({
  type: SAVE_BLOG,
  payload
})

export const blogSaved = () => ({
  type: BLOG_SAVED,
  // payload: response
})

export const updateBlog = (payload) => ({
  type: UPDATE_BLOG,
  payload
})

export const blogUpdated = () => ({
  type: BLOG_UPDATED,
})

export const fetchBlogs = () => ({
  type: FETCH_BLOGS,
})

export const fetchBlog = (payload) => ({
  type: FETCH_BLOG,
  payload
})

export const translateText = (payload) => ({
  type: TRANSLATE_TEXT,
  payload
})

export const createUser = (payload) => ({
  type: CREATE_USER,
  payload
})

export const fetchUsers = () => ({
  type: FETCH_USERS,
})

export const fetchStatics = () => ({
  type: FETCH_STATICS,
})

export const staticsFetched = ({ response }) => ({
  type: STATICS_FETCHED,
  payload: response
})

export const updateStatics = (payload) => ({
  type: UPDATE_STATICS,
  payload
})

export const usersFetched = ({ response }) => ({
  type: USERS_FETCHED,
  payload: response
})

export const fetchCategories = () => ({
  type: FETCH_CATEGORIES,
})

export const categoriesFetched = ({ response }) => ({
  type: CATEGORIES_FETCHED,
  payload: response
})

export const fetchLanguages = () => ({
  type: FETCH_LANGUAGES,
})

export const languagesFetched = ({ response }) => ({
  type: LANGUAGES_FETCHED,
  payload: response
})

export const createRole = (payload) => ({
  type: CREATE_ROLE,
  payload
})

export const fetchRoles = () => ({
  type: FETCH_ROLES,
})

export const rolesFetched = ({ response }) => ({
  type: ROLES_FETCHED,
  payload: response
})

export const fetchDevices = () => ({
  type: FETCH_DEVICES,
})

export const devicesFetched = ({ response }) => ({
  type: DEVICES_FETCHED,
  payload: response
})

export const fetchAttendance = (payload) => ({
  type: FETCH_ATTENDANCE,
  payload
})

export const attendanceFetched = ({ response }) => ({
  type: ATTENDANCE_FETCHED,
  payload: response
})


export const updateDevice = (payload) => ({
  type: UPDATE_DEVICE,
  payload
})

export const deviceUpdated = () => ({
  type: DEVICE_UPDATED,
})

export const requestRegister = (payload) => ({
  type: REQUEST_REGISTER,
  payload
})

export const registerRequested = ({ response }) => ({
  type: REGISTER_REQUESTED,
  payload: response
})

export const recordAttendance = (payload) => ({
  type: RECORD_ATTENDANCE,
  payload
})

export const attendanceRecorded = () => ({
  type: ATTENDANCE_RECORDED,
})

export const customMiddle = (payload) => ({
  type: CUSTOM_MIDDLE_REQUEST,
  payload
})

export const customMiddleResponse = (payload) => ({
  type: CUSTOM_MIDDLE_RESPONSE,
  payload
})

export const UploadProgress = (value) => ({
  type: UP_PGR,
  payload: value
})

export const DownloadProgress = (value) => ({
  type: DN_PGR,
  payload: value
})